import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const deleteDriver = id =>
  privateAxios({
    method: 'delete',
    baseURL: adminAPI,
    url: `/driver/${id}`,
  });
